import { API } from './apiClient'
import { Product, EmailUpdateValue, PhoneUpdateValue, CustomerData, AddressUpdateValue } from '../models/contractsModel'

const BASE_URL = '/contracts'

export const getProductsByEmail = (onetimeKey: string): Promise<Product[]> => {
  return API.get(`${BASE_URL}/email`, {
    headers: { Authorization: onetimeKey },
  })
}

export const putUpdateEmail = (data: EmailUpdateValue, onetimeKey: string): Promise<void> => {
  return API.put(`${BASE_URL}/email`, data, {
    headers: { Authorization: onetimeKey },
  })
}

export const putUpdatePhone = (data: PhoneUpdateValue, onetimeKey: string): Promise<void> => {
  return API.put(`${BASE_URL}/phone`, data, {
    headers: { Authorization: onetimeKey },
  })
}

export const getProductByInquiryCode = (inquiryCode: string, onetimeKey: string): Promise<Product> => {
  return API.get(`${BASE_URL}/inquiry-code/${inquiryCode}`, {
    headers: { Authorization: onetimeKey },
  })
}

export const getProductByCustomerData = (params: CustomerData): Promise<Product> => {
  const { contractId, customerId } = params
  return API.get(`${BASE_URL}/${contractId}/customer/${customerId}`)
}

export const putUpdateAddress = (data: AddressUpdateValue, onetimeKey: string): Promise<void> => {
  return API.put(`${BASE_URL}/shipping-address`, data, {
    headers: { Authorization: onetimeKey },
  })
}
